import { render, staticRenderFns } from "./TreatmentPlanRequestRejectModal.vue?vue&type=template&id=b240590c&scoped=true&"
import script from "./TreatmentPlanRequestRejectModal.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanRequestRejectModal.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanRequestRejectModal.vue?vue&type=style&index=0&id=b240590c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b240590c",
  null
  
)

export default component.exports